<template>
  <div>
    <template v-if="loading_endereco === true">
      <loading />
    </template>
    <template v-else>
      <div class="col s12 m12 no-padding contact-section">
        <div class="col s12 no-padding title-buttons-wrapper">
          <div class="col s6">
            <h6>
              Endereço
              <i v-if="enderecos.length > 0" class="material-icons">check</i>
              <template v-else>
                <i v-if="meta.censo_domain[selectedMunicipio].formulario_documentos_obrigatorios.contatos.includes('enderecos')" class="material-icons red-text">error</i>
              </template>
            </h6>
          </div>
          <div class="col s6">
            <a v-if="form_endereco === false" @click="addNewAddress" class="waves-effect waves-light btn right">Adicionar endereço</a>
            <a v-else @click="addNewAddress" class="waves-effect waves-light btn red right">Cancelar</a>
          </div>
        </div>
        <div v-if="form_endereco === false" class="col s12 no-padding lista-endereco-wrapper">
          <template v-for="(end, i) in enderecos">
            <div class="col s12 m6 l4 xl2" v-bind:key="i">
              <div class="card">
                <div class="card-content">
                  <div class="col s12">
                    <p>
                      <span>{{ end['tipo_logradouro'] }} {{ end['logradouro'] }}</span>
                      <span v-if="end['complemento'] != null">{{ end['complemento'] }}</span>
                      <span>
                        Bairro: {{ end['end_bairro'] }}
                      </span>
                      <span v-if="isBrasilEnd(end)">
                        CEP: {{ end['cep'] }} - {{ end['end_cidade'] }}/{{ end['end_uf'] }}
                      </span>
                      <template v-else>
                        <span>
                          {{ end['end_cidade'] }} / {{ end['end_uf'] }}
                        </span>
                        <span>
                          País: {{ paises_nomes[end['end_pais_id']] }}
                        </span>
                      </template>
                    </p>
                  </div>
                </div>
                <div class="card-action">
                  <div class="col s12 censo">
                    <a @click="removeEndereco(end['end_id'])" title="Remover endereço" class="red-text action-delete cursor-pointer">
                      <i class="material-icons">delete</i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
        <div v-else class="col s12 no-padding form-endereco-wrapper">
          <div class="col s12 m12">
            <div class="input-field col s12 m6">
              <combo-box
                v-model="new_end.end_pais_id"
                :options="paisesOptions"
                label="País"
                placeholder="Selecione"
              />
            </div>
            <div v-if="isBrasil" class="input-field col s12 m6">
              <input @keyup="searchCEP" v-model="new_end.end_cep" v-mask="['#####-###']" id="end_cep" type="text" v-bind:class="{'invalid': error_fields['end_cep']}">
              <label for="cep">CEP</label>
              <span class="helper-text" data-error="Este campo deve ser preenchido"></span>
            </div>
            <div class="input-field col s12 m6">
              <select v-model="new_end.end_tipo_lograd" v-bind:class="{'invalid': error_fields['end_tipo_lograd']}" id="end_tipo_lograd">
                <option v-bind:value="null" selected>Selecione</option>
                <option v-for="(t_lograd, i) in meta.end_tipos_lograd.filter(tl => (new RegExp('^[0-9]')).test(tl) === false)" v-bind:key="i" v-bind:value="t_lograd.toUpperCase()">{{ t_lograd.toUpperCase() }}</option>
              </select>
              <label>Tipo do logradouro</label>
              <span class="helper-text" data-error="Este campo deve ser preenchido"></span>
            </div>
            <div class="input-field col s12">
              <input v-model="new_end.end_lograd" id="end_lograd" type="text" v-bind:class="{'invalid': error_fields['end_lograd']}">
              <label for="logradouro">Logradouro</label>
              <span class="helper-text" data-error="Este campo deve ser preenchido"></span>
            </div>
            <div class="input-field col s12 m2">
              <input v-model="new_end.end_num" id="end_num" type="text" v-bind:class="{'invalid': error_fields['end_num']}">
              <label for="numero">Número</label>
              <span class="helper-text" data-error="Este campo deve ser preenchido"></span>
            </div>
            <div class="input-field col s12 m6">
              <input v-model="new_end.end_compl" id="end_compl" type="text" v-bind:class="{'invalid': error_fields['end_compl']}">
              <label for="complemento">Complemento</label>
              <span class="helper-text" data-error="Este campo deve ser preenchido"></span>
            </div>
            <div class="input-field col s12 m4">
              <input v-model="new_end.end_bairro" id="end_bairro" type="text" v-bind:class="{'invalid': error_fields['end_bairro']}">
              <label for="bairro">Bairro</label>
              <span class="helper-text" data-error="Este campo deve ser preenchido"></span>
            </div>
            <div class="input-field col s12 m5">
              <input v-model="new_end.end_cidade" id="end_cidade" type="text" v-bind:class="{'invalid': error_fields['end_cidade']}">
              <label for="cidade">Cidade</label>
              <span class="helper-text" data-error="Este campo deve ser preenchido"></span>
            </div>
            <div class="input-field col s12 m3">
              <combo-box
                v-if="isBrasil"
                v-model="new_end.end_uf"
                :options="ufOptions"
                label="UF"
                placeholder="Selecione"
              />
              <template v-else>
                <input v-model="new_end.end_uf" id="end_uf_livre" type="text">
                <label for="end_uf_livre">Estado / Província / Região</label>
              </template>
            </div>
            <div class="input-field col s12 m4">
              <select v-model="new_end.end_class" id="end_class" v-bind:class="{'invalid': error_fields['end_class']}">
                <option v-bind:value="null" selected>Selecione</option>
                <option value="R">Residencial</option>
                <option value="C">Comercial</option>
                <option value="CR">Correspondência</option>
                <option value="RC">Recado</option>
                <option value="T">Temporário</option>
              </select>
              <label for="class_end">Classificação</label>
              <span class="helper-text" data-error="Este campo deve ser preenchido"></span>
            </div>
            <div class="input-field col s12 m12">
              <textarea v-model="new_end.end_obs" class="materialize-textarea" id="class_obs"></textarea>
              <label for="class_obs">Observação</label>
            </div>
            <div class="col s12 m12">
              <a @click="prepareSubmitEndereco" v-bind:disabled="verificaForm === false" class="waves-effect waves-light btn right">Salvar</a>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Loading from '@/components/Loading.vue'
import ComboBox from '@/components/utils/ComboBox.vue'
import axios from 'axios'
import {CONFIG} from '@/config/config.js'
import SocialService from '@/services/social-service.js'

let socialService = new SocialService(CONFIG.URL_SOCIAL_API_V2)

export default {
  name: 'Enderecos',
  components: {
    loading: Loading,
    'combo-box': ComboBox
  },
  props: {
    endereco_data: Array,
    pf_id: String
  },
  data (){
    return {
      meta: this.$store.state.meta.data,
      loading_endereco: false,
      form_endereco: false,
      enderecos: this.endereco_data,
      new_end: {
        end_cidade: null,
        end_uf: null,
        end_bairro: null,
        end_cep: null,
        end_pais_id: 33, // Brasil
        end_tipo_lograd: null,
        end_lograd: null,
        end_num: null,
        end_compl: null,
        end_class: null,
        end_obs: null,
        bairro_id: null,
        cidade_id: null,
      },
      error_fields: {},
      selectedMunicipio: localStorage.selectedMunicipio,
      paises_nomes: {}
    }
  },
  computed: {
    isBrasil() {
      return this.new_end.end_pais_id === 33
    },
    paisesOptions() {
      return Object.keys(this.paises_nomes)
        .map((id) => ({ value: parseInt(id, 10), label: this.paises_nomes[id] }))
        .sort((a, b) => a.label.localeCompare(b.label, 'pt-BR'))
    },
    ufOptions() {
      return Object.keys(this.meta.uf).map((key) => ({ value: key, label: this.meta.uf[key] }))
    },
    verificaForm: function() {
      let campos = this.isBrasil
        ? ['end_cidade', 'end_uf', 'end_bairro', 'end_tipo_lograd', 'end_class']
        : ['end_cidade', 'end_bairro', 'end_tipo_lograd', 'end_class']
      return campos.filter((k) => this.new_end[k] && this.new_end[k] != '').length >= campos.length
    }
  },
  methods: {
    getEnderecos(){
      axios.get(`${CONFIG.URL_SOCIAL_API_V2}/v2/pessoa-fisica/enderecos/${this.pf_id}/`)
      .then((response) => {
        this.enderecos = []
        response.data.data.SocialAPI.forEach((end) => {
          this.enderecos.push({
            ...end,
            ...{
              'tipo_logradouro': end['end_tipo_lograd'],
              'logradouro': end['end_lograd'],
              'complemento': end['end_compl'],
              'cep': end['end_cep']
            }
          })
          this.$emit('statusChange')
        })
      })
      .catch((error) => {

      })
      .finally(() => {
        this.loading_endereco = false
        setTimeout(() => {
          this.form_endereco = false
        }, 100)
      })
    },
    async submitInsertEndereco(endereco){
      axios.post(`${CONFIG.URL_SOCIAL_API_V2}/v2/pessoa-fisica/enderecos/`, {
        ...endereco,
        ...{
          'pf_id': this.pf_id,
          'end_cep': (this.isBrasil && this.new_end.end_cep ? this.new_end.end_cep.replace(/[^0-9]/g, '') : ''),
          'end_uf': (this.new_end.end_uf ? this.new_end.end_uf.substring(0, 100) : ''),
          'device': await socialService.getDeviceInfo()
        }
      })
      .then((response) => {
        this.getEnderecos()
      })
      .catch((error) => {
        M.toast({html: 'Não foi possível realizar esta operação...verifique a sua conexão com a internet e tente novamente!'})
        this.loading_endereco = false
        this.loadFields()
      })
    },

    prepareSubmitEndereco(){
      this.loading_endereco = true
      return this.submitInsertEndereco(this.new_end)
    },
    addNewAddress() {
      this.form_endereco = !this.form_endereco
      if (this.form_endereco === true) {
        this.loadFields()
        this.new_end = {
          end_cidade: null,
          end_uf: null,
          end_bairro: null,
          end_cep: null,
          end_pais_id: 33, // Brasil
          end_tipo_lograd: null,
          end_lograd: null,
          end_num: null,
          end_compl: null,
          end_class: null,
          end_obs: null,
        }
      }
    },
    async removeEndereco(end_id){
      this.loading_endereco = true
      axios({
        method: "DELETE",
        url: `${CONFIG.URL_SOCIAL_API_V2}/v2/pessoa-fisica/enderecos/${this.pf_id}/${end_id}/`, 
        data: {
          device: await socialService.getDeviceInfo()
        }
      })
      .then((response) => {
        this.enderecos.forEach((item, i) => {
          if(item['end_id'] === end_id){
            this.enderecos.splice(i, 1)
          }
        })
        this.$emit('statusChange')
        this.loading_endereco = false
      })
      .catch((error) => {
        M.toast({html: 'Não foi possível realizar esta operação...verifique a sua conexão com a internet e tente novamente!'})
        this.loading_endereco = false
        setTimeout(() => {
          this.loadFields()
        }, 100)
      })
    },
    getCepInfo(cep){
      axios.get(`${CONFIG.URL_UFCIDADE_API}/v1/cep/${cep}/`)
      .then((response) => {
        if('entidade_cep' in response.data.data){
          this.cep_info = response.data.data.entidade_cep
          this.setCepInfo(this.cep_info)
        } else {
          this.cep_info = {}
          this.setCepInfo(this.cep_info)
        }
      })
      .catch((error) => {
        if(error.response.status != 404){
          M.toast({html: "Ops! Não foi possível realizar esta operação...tente novamente em instantes."})
        }
      })
      .finally(() => {
        this.$root.$emit('stopLoadingHeader')
        this.locked = false
      })
    },
    setCepInfo(info){
      if('cidade' in info){
        this.new_end.end_cidade = info['cidade']['cidade']
        this.new_end.end_uf = info['uf']['uf_sigla']
        this.new_end.end_bairro = info['bairro']['bairro']
        this.new_end.end_tipo_lograd = info['endereco']['tipo_logradouro'].toUpperCase()
        this.new_end.end_lograd = info['endereco']['logradouro'].toUpperCase()
      } else {
        this.new_end.end_cidade = null
        this.new_end.end_uf = null
        this.new_end.end_bairro = null
        this.new_end.end_tipo_lograd = null
        this.new_end.end_lograd = null
      }
      this.loadFields()
    },
    searchCEP(){
      if(this.isBrasil === false){
        return
      }
      let end_cep = this.new_end['end_cep'].replace(/\D/g, '')
      if(end_cep.length === 8){
        this.$root.$emit('loadingHeader')
        this.locked = true
        this.getCepInfo(end_cep)
      } else {
        this.cep_info = {}
        this.setCepInfo(this.cep_info)
      }
    },
    isBrasilEnd(end) {
      return !end['end_pais_id'] || end['end_pais_id'] === 33
    },
    async loadPaises(){
      try {
        let cached = sessionStorage.getItem('censo_paises_list')
        if(cached){
          this.paises_nomes = JSON.parse(cached)
          return
        }
      } catch(e) {
        //NO-ACTION
      }

      let letras = 'abcdefghijklmnopqrstuvwxyz'.split('')
      let mapa = {}
      await Promise.all(letras.map((letra) => {
        return axios.get(`${CONFIG.URL_UFCIDADE_API}/v1/pais/nome/${letra}/`)
        .then((response) => {
          response.data.data.UFCidadeAPI.forEach((opt) => {
            mapa[opt['pais_id']] = opt['pais_nome']
          })
        })
        .catch((error) => {
          //NO-ACTION
        })
      }))
      this.paises_nomes = mapa
      try {
        sessionStorage.setItem('censo_paises_list', JSON.stringify(mapa))
      } catch(e) {
        //NO-ACTION
      }
    },
    verificaStatusPasso(){
      let keys = ['end_cidade', 'end_bairro', 'end_lograd']
      let selectKeys = ['end_tipo_lograd', 'end_class']
      if(this.isBrasil){
        keys.push('end_cep', 'end_uf')
      }

      let status = true //Até que se prove o contrário
      keys.forEach((key) => {
        if(this.new_end[key] == null || this.new_end[key] == ''){
          status = false
          this.$set(this.error_fields, key, true)
        } else {
          this.$set(this.error_fields, key, false)
        }
      })

      selectKeys.forEach((sKey) => {
        try{
          if(this.new_end[sKey] === null || this.new_end[sKey] === ''){
            status = false
            M.FormSelect.getInstance(document.getElementById(sKey)).wrapper.classList.add('invalid')
            this.$set(this.error_fields, sKey, false)
          } else {
            M.FormSelect.getInstance(document.getElementById(sKey)).wrapper.classList.remove('invalid')
            this.$set(this.error_fields, sKey, true)
          }
        } catch(e) {
          status = false
        }
      })
      return status
    },
    loadFields() {
      setTimeout(() => {
        M.updateTextFields()
        M.FormSelect.init(document.querySelectorAll('select'))
        M.Tooltip.init(document.querySelectorAll('.tooltipped'))
      }, 200)
    },
  },
  watch: {
    new_end: {
      handler: function(updated, old){
        setTimeout(() => {
          this.verificaStatusPasso()
        }, 300)
      },
      deep: true
    },
    isBrasil(){
      this.loadFields()
    }
  },
  mounted(){
    this.loadPaises()
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/steps/contatos/Enderecos.vue